import { createNonceStr, md5, getLocationSearch } from '@/utils/utils'
import request from '@/utils/request'
export const driverMoney = (url,params) => {
  //获取token
  let getToken = getLocationSearch().token
  return new Promise((resolve) => {
    let appKey = 'app_h5';
    let secret = '11dc72cf-88b0-46cd-91d7-b1a77fd69ee1';
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let token = getToken;
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    request.post(url, {
      ...params
    }, {
      appKey: appKey,
      timestamp: timestamp,
      random: random,
      token: token,
      sign: sign
    })
    .then( (d) => {
      resolve(d);
    } )
  })
}